import { Card, CardProps, Flex, FlexProps, rem, Text, TextProps } from "@mantine/core"
import MarkerPinIcon from "common/icons/marker-pin"
import PhoneIcon from "common/icons/phone"
import WebIcon from "common/icons/web"
import Link from "next/link"
import { FC } from "react"





const FooterContactItem: FC<FlexProps> = ({ ...props }) => {

    const flexProps: FlexProps = {
        align: "center",
        gap: { base: 19, sm: 16 },
        py: 12,
        style: {
            borderBottom: "1px solid #FFFFFF33"
        },
        w: { sm: "fit-content" }
    }

    const textProps: TextProps = {
        c: "white",
        fw: 400,
        fz: { base: rem(14), sm: rem(20) },
        lh: { base: rem(21), sm: rem(30) },
    }

    const cardProps: CardProps = {
        radius: 8,
        bd: "1px solid #FFFFFF4D",
        bg: "transparent",
        p: 4
    }


    return (
        <>
            <Flex
                direction="column"
                gap={8}
                align="stretch"
                {...props}
            >
                <Flex {...flexProps}>
                    <Card {...cardProps}>
                        <PhoneIcon />
                    </Card>

                    <Link href="tel:02191091243" color="white">
                        <Text {...textProps}>
                            تلفن بخش صنعت: 02191091243
                        </Text>
                    </Link>
                </Flex>

                <Flex {...flexProps}>
                    <Card {...cardProps}>
                        <MarkerPinIcon />
                    </Card>

                    <Text {...textProps}>
                        آدرس : مشهد، ابتدای خیابان پیروزی، میدان کاوه، مجتمع فنی حرفه ای، ساختمان تیراژ
                    </Text>
                </Flex>

                <Flex {...flexProps} bd={0}>
                    <Card {...cardProps}>
                        <WebIcon />
                    </Card>

                    <Link href={process.env.NEXT_PUBLIC_SITE_URL}>
                        <Text {...textProps}>
                            www.salamsakhteman.com
                        </Text>
                    </Link>
                </Flex>
            </Flex>
        </>
    )
}

export default FooterContactItem